import { render } from "./RawMaterialSpecificationComponent.vue?vue&type=template&id=36399781&scoped=true"
import script from "./RawMaterialSpecificationComponent.vue?vue&type=script&lang=js"
export * from "./RawMaterialSpecificationComponent.vue?vue&type=script&lang=js"

import "./RawMaterialSpecificationComponent.vue?vue&type=style&index=0&id=36399781&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36399781"]])

export default __exports__